module.exports = __webpack_public_path__ + "img/next.a6d30310.svg";